import type { API } from 'chessboard/api/config/types';
import JCE from '@chesscom/js-chess-engine';
import type { Game } from 'chessboard/model/game/types';

/**
 * Formats an API move into one that can be passed to JCE.
 * Returns null on illegal san-only move (string or { san: '' }).
 */
export function formatAPIMove(
  move: API.Options.Move | string,
  fen: string,
  variant: Game.Variants,
): Game.Move.FormattedMove | null {
  let moveDetails: Game.Move.FormattedMove | null;

  if (typeof move === 'string') {
    moveDetails = JCE.sanToObj(move, fen, variant); // can return null/false on illegal move
  } else if ('san' in move) {
    if ('to' in move) {
      moveDetails = move;
    } else {
      const { san, ...rest } = move;
      const details = JCE.sanToObj(san, fen, variant); // can return null/false on illegal move
      moveDetails = details
        ? {
            ...details,
            ...rest,
          }
        : null;
    }
  } else if ('tcn' in move) {
    const { tcn, ...rest } = move;
    moveDetails = {
      ...JCE.decodeTCN(tcn)[0],
      ...rest,
    };
  } else {
    moveDetails = move;
  }

  return moveDetails
    ? {
        animate: true, // default animate to true
        ...moveDetails,
      }
    : null;
}
